import { Block } from '@galio';

export default Block;
